import type { Graph3DData, Graph3DPositionedNode } from '../core/graph.types';
import type { Graph3DLayoutConfig } from '../core/layout.types';
import { applyLayeredLayout } from './applyLayeredLayout';

export function applyDagreLayout<TNodeData = unknown>(
  data: Graph3DData<TNodeData>,
  config: Graph3DLayoutConfig = {}
): Graph3DPositionedNode<TNodeData>[] {
  return applyLayeredLayout(data, { ...config, type: 'dagre-like' });
}
